import { CSSProperties } from "react";
import { GenericImageSettings, GenericImages } from "types/types";
import { IGatsbyImageData } from "gatsby-plugin-image";
import { Infer, enums, nullable, object, string } from "superstruct";
import { ModCfFileImage } from "types/cf-utils/types";
import { modelAcceptHasParentLink } from "utilities/validatoros/types";

export type LoadingType = "lazy" | "eager";
export type PriorityType = "low" | "high" | "auto";

export const ModCfImage = object({
  __typename: enums(["ContentfulImageV2", "ContentfulAsset"]),
  id: string(),
  contentful_id: string(),
  alt: nullable(string()),
  slug: nullable(string()),
  customClass: nullable(string()),
  imageDesktop: ModCfFileImage,
  imageMobile: nullable(ModCfFileImage),
});

export const ModCfImageProps = modelAcceptHasParentLink(ModCfImage);

export type CfImageProps = Omit<
  Infer<typeof ModCfImageProps>,
  "imageDesktop" | "imageMobile"
> &
  GenericImages &
  GenericImageSettings;

export type CfImageSingleProps = Omit<
  CfImageProps,
  "__typename" | "id" | "contentful_id"
>;

export type BaseImageProps = {
  slug?: string;
  alt: string;
  customClass?: string;
  imageDesktop: string;
  imageMobile?: string;
  loadingType?: LoadingType;
  featchPriority?: PriorityType;
  objectFit?: CSSProperties["objectFit"];
};

export type ImageProps = BaseImageProps & {
  gatsbyImage?: IGatsbyImageData;
};
